export const worklogStatuses = {
  workFromOffice: 1,
  homeOffice: 2,
  notWokring: 3,
  onBreak: 4,
  awayFromKeyboard: 5,
  busy: 6,
};
